import Vue from 'vue';
import dayjs from 'dayjs';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../../tailwind.config.js';

const fullConfig = resolveConfig(tailwindConfig);

export default function() {
  Vue.component('popup', {
    data() {
      return {
        isPopupVisibleRef: null
      };
    },

    mounted() {
      if (window.innerWidth >= parseInt(fullConfig.theme.screens.sm, 10)) {
        this.isPopupVisibleRef = false;
      }

      let lastOpened = localStorage.getItem('lastOpened');
      let hours = dayjs().diff(dayjs(lastOpened), 'hours');

      localStorage.setItem('lastOpened', dayjs());

      //Do NOT show the pop-up if 1 hour is not passed
      if (hours < 1) {
        this.isPopupVisibleRef = false;
      } else {
        this.isPopupVisibleRef = true;
      }
    },

    methods: {
      close() {
        this.isPopupVisibleRef = false;
      }
    }
  });
}
